module.exports =  {
    startLineRef: 2.5,
    lengthFreq: 15.915494309,
    lineRefDiff: 0.8,
    startPoint: 0,
    startLineRefU100: 2,
    freqFirst100Level: 0.5,
    maxFreq: 2.5,
    startFreq: 1.1,
    diffFreq: 0.175,
    levelPerDiffFreq: 100,
    maxFreqLine1k: 6.9,
    maxFreqLine10k: 8.25,
};